import React from 'react';
import { Folder, Trash2, MoreVertical } from 'lucide-react';
import { formatDate } from '../../utils/helpers';

const ProjectList = ({ projects, selectedProject, onProjectSelect, onProjectDelete }) => {
  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200">
      <div className="p-4 border-b border-gray-200">
        <h3 className="text-lg font-semibold text-gray-900">Projects</h3>
        <p className="text-sm text-gray-500 mt-1">
          {projects.length} project{projects.length !== 1 ? 's' : ''}
        </p>
      </div>

      <div className="max-h-96 overflow-y-auto">
        {projects.length === 0 ? (
          <div className="p-8 text-center">
            <Folder className="h-12 w-12 text-gray-400 mx-auto mb-3" />
            <p className="text-gray-500 text-sm">No projects yet</p>
          </div>
        ) : (
          <div className="divide-y divide-gray-200">
            {projects.map((project) => (
              <div
                key={project.id}
                className={`p-4 hover:bg-gray-50 cursor-pointer transition-colors ${
                  selectedProject?.id === project.id ? 'bg-blue-50 border-r-2 border-blue-500' : ''
                }`}
                onClick={() => onProjectSelect(project)}
              >
                <div className="flex items-start justify-between">
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center">
                      <Folder className="h-4 w-4 text-blue-600 mr-2 flex-shrink-0" />
                      <h4 className="text-sm font-medium text-gray-900 truncate">
                        {project.name}
                      </h4>
                    </div>
                    <p className="text-xs text-gray-500 mt-1 truncate">
                      {project.framework}
                    </p>
                    <p className="text-xs text-gray-400 mt-1">
                      {formatDate(project.updated_at)}
                    </p>
                  </div>

                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      onProjectDelete(project.id);
                    }}
                    className="ml-2 p-1 text-gray-400 hover:text-red-600 transition-colors"
                    title="Delete project"
                  >
                    <Trash2 className="h-4 w-4" />
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default ProjectList;